
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const syncOrderSlice = createApi({
    reducerPath: "syncOrder",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        syncOrder: builder.query({
            query: (data) => ({ url: "/order-management/api/v1/sync-orders", params: data, method: "GET" }),
        }),
    }),
});

export const { useSyncOrderQuery } = syncOrderSlice;

